class TreatmentSingleSelectController {
  constructor(treatmentsService) {
    this.treatmentsService = treatmentsService;
  }

  $onInit(){
    if (!this.treatments){
      this.treatmentsService.findAll(-1).then(result => {
          this.treatments = result;
          this.treatments.unshift({id: '', name: 'None', category: 'Select no Treatment'});
      });
    }
  }
}

TreatmentSingleSelectController.$inject = [ 'treatmentsService' ];

export default TreatmentSingleSelectController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/controllers/treatment.single.select.controller.js